module.exports = __webpack_public_path__ + "static/media/car-garage.282d4428.svg";